import Vue from 'vue'

import Modal from '@/components/modal/modal.vue'

export default Vue.extend({
  props: {
    announcement: {
      type: Object as Prop<model.Announcement>,
      required: true
    }
  },

  components: {
    'modal': Modal
  },

  methods: {
    close () {
      this.$emit('close')
    }
  }
})
